
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const VerticalArrowsIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m8 10 4-4 4 4M8 14l4 4 4-4"/></svg>
  </SvgIcon>
);
